export default __webpack_public_path__ + "static/media/PromoBannerCoke.651b29c7.png";